module.exports = __webpack_public_path__ + "img/60.195a8aa5.png";